<template>
  <v-card outlined rounded="lg" :loading="loading" class="pa-3 h-100">
    <div class="section-card-title">
      <v-icon color="#B3151B" class="mr-2">mdi-card-account-details</v-icon>
      ข้อมูลติดต่อสถานศึกษา
    </div>

    <v-list dense class="contact-list">
      <v-list-item>
        <v-list-item-icon><v-icon color="#B3151B" small>mdi-map-marker</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="contact-text">
            {{ std02college.houseNumber }} หมู่ {{ std02college.villageNumber }}
            ซอย {{ std02college.soi }} ถนน {{ std02college.street }}
            ต. {{ std02college.tumbolCode }} รหัสไปรษณีย์ {{ std02college.zipcode }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="std02college.telephone">
        <v-list-item-icon><v-icon color="#B3151B" small>mdi-phone</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title class="contact-text">{{ std02college.telephone }}</v-list-item-title></v-list-item-content>
      </v-list-item>
      <v-list-item v-if="std02college.fax">
        <v-list-item-icon><v-icon color="#B3151B" small>mdi-fax</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title class="contact-text">{{ std02college.fax }}</v-list-item-title></v-list-item-content>
      </v-list-item>
      <v-list-item v-if="std02college.email">
        <v-list-item-icon><v-icon color="#B3151B" small>mdi-email</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title class="contact-text">{{ std02college.email }}</v-list-item-title></v-list-item-content>
      </v-list-item>
      <v-list-item v-if="std02college.website">
        <v-list-item-icon><v-icon color="#B3151B" small>mdi-web</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-btn small text color="#1B365D" class="pl-0" @click="weblink(std02college.website)">
            {{ std02college.website }}
          </v-btn>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
// ดึงข้อมูลที่ตั้ง/ติดต่อจากระบบ std2018-api ของ สอศ. (std02college.php) แล้วส่งต่อให้ parent ผ่าน
// event "loaded" สำหรับใช้ในชุดส่งออก Excel — ดูเหตุผลการแยก fetch ต่อ widget ที่ stdLevel.vue
export default {
  name: "DashboardOvecMasterCollegeStd02",

  data() {
    return {
      std02college: {},
      loading: true
    };
  },

  async mounted() {
    await this.std02collegeQuery();
  },

  methods: {
    async weblink(website) {
      let textlink = String(website);
      let httpck = textlink.slice(0, 4);
      if (httpck == "www.") {
        window.open("http://" + website, "_blank").focus();
      } else {
        window.open(website, "_blank").focus();
      }
    },
    async std02collegeQuery() {
      try {
        this.loading = true;
        let result = await this.$http.post("std02college.php", {
          SchoolID: this.college_ID
        });
        this.std02college = (result.data && result.data.SchoolDetail) || {};
        this.$emit("loaded", this.std02college);
      } catch (error) {
        this.$emit("loaded", null);
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    college_ID() {
      return this.$route.query.college_ID;
    }
  }
};
</script>

<style scoped>
.h-100 {
  height: 100%;
}
.section-card-title {
  display: flex;
  align-items: center;
  font-weight: 700;
  color: #1b365d;
  font-size: 1rem;
  margin-bottom: 8px;
}
.contact-text {
  white-space: normal !important;
  line-height: 1.5;
}
</style>
